import React, {useContext,useState,useEffect} from "react"
import { useSelector } from "react-redux";

const AWS = require('aws-sdk');
const DBContext=React.createContext()

export function useDB(){
    return useContext(DBContext)
}

export function DBProvider({children}){
    const [dynamoDBClient, setdynamoDBClient] = useState(null)
    const {secretKey,accessKey}=useSelector(state=>state.userKeyRed)

    useEffect(() => {
        if(secretKey!==null && accessKey!==null){
            setDBClient(secretKey,accessKey)
        }
    }, [])

    function setDBClient(secretKey,accessKey){
        AWS.config.update({
            region: window.databaseRegion,
            accessKeyId: accessKey ,
            secretAccessKey: secretKey,
        });
        const dynamoDB=new AWS.DynamoDB.DocumentClient()
        setdynamoDBClient(dynamoDB)
    }

    return <DBContext.Provider value={{dynamoDBClient,setDBClient}}>
            {children}
    </DBContext.Provider>

}